// Single source of truth for the Process Portal default menu items.
// Runtime sidebar (SiderMenu) and the portal configurator preview both derive
// their default entries from this list. `hideKey` maps each item to the portal
// flag (from auth/portal) that hides it; `labelId`/`icon` are used by the
// configurator preview (runtime resolves name/icon from the real route defs).
export const PORTAL_DEFAULT_MENU = [
  { path: '/', hideKey: 'hideMenuItemHome', labelId: 'menu.home', icon: 'Home-filled' },
  { path: '/tasks', hideKey: 'hideMenuItemTasks', labelId: 'menu.tasks', icon: 'Update' },
  {
    path: '/applications',
    hideKey: 'hideMenuItemRequests',
    labelId: 'menu.applications',
    icon: 'Offline-bolt',
  },
];

export const isPortalItemVisible = (item, portal) => portal?.[item.hideKey] !== true;
